[
  {
    "name": "2024-12-16Z.md",
    "path": "src/assets/release-notes/2024-12-16Z.md"
  },
  {
    "name": "2025-01-06Z.md",
    "path": "src/assets/release-notes/2025-01-06Z.md"
  },
  {
    "name": "2025-01-20Z.md",
    "path": "src/assets/release-notes/2025-01-20Z.md"
  },
  {
    "name": "2025-02-06Z.md",
    "path": "src/assets/release-notes/2025-02-06Z.md"
  },
  {
    "name": "2025-02-27Z.md",
    "path": "src/assets/release-notes/2025-02-27Z.md"
  },
  {
    "name": "2025-03-18Z.md",
    "path": "src/assets/release-notes/2025-03-18Z.md"
  },
  {
    "name": "2025-04-02Z.md",
    "path": "src/assets/release-notes/2025-04-02Z.md"
  },
  {
    "name": "2025-04-29Z.md",
    "path": "src/assets/release-notes/2025-04-29Z.md"
  },
  {
    "name": "2025-05-12Z.md",
    "path": "src/assets/release-notes/2025-05-12Z.md"
  },
  {
    "name": "2025-05-28Z.md",
    "path": "src/assets/release-notes/2025-05-28Z.md"
  },
  {
    "name": "2025-06-05Z.md",
    "path": "src/assets/release-notes/2025-06-05Z.md"
  },
  {
    "name": "2025-06-12Z.md",
    "path": "src/assets/release-notes/2025-06-12Z.md"
  },
  {
    "name": "2025-06-20Z.md",
    "path": "src/assets/release-notes/2025-06-20Z.md"
  },
  {
    "name": "2025-06-26Z.md",
    "path": "src/assets/release-notes/2025-06-26Z.md"
  },
  {
    "name": "2025-07-08Z.md",
    "path": "src/assets/release-notes/2025-07-08Z.md"
  },
  {
    "name": "2025-07-21Z.md",
    "path": "src/assets/release-notes/2025-07-21Z.md"
  },
  {
    "name": "2025-07-22Z.md",
    "path": "src/assets/release-notes/2025-07-22Z.md"
  },
  {
    "name": "2025-07-30Z.md",
    "path": "src/assets/release-notes/2025-07-30Z.md"
  },
  {
    "name": "2025-08-14Z.md",
    "path": "src/assets/release-notes/2025-08-14Z.md"
  },
  {
    "name": "2025-08-27Z.md",
    "path": "src/assets/release-notes/2025-08-27Z.md"
  },
  {
    "name": "2025-09-03Z.md",
    "path": "src/assets/release-notes/2025-09-03Z.md"
  },
  {
    "name": "2025-09-16Z.md",
    "path": "src/assets/release-notes/2025-09-16Z.md"
  },
  {
    "name": "2025-10-14Z.md",
    "path": "src/assets/release-notes/2025-10-14Z.md"
  },
  {
    "name": "2025-11-03Z.md",
    "path": "src/assets/release-notes/2025-11-03Z.md"
  },
  {
    "name": "2025-11-20Z.md",
    "path": "src/assets/release-notes/2025-11-20Z.md"
  },
  {
    "name": "2025-11-24Z.md",
    "path": "src/assets/release-notes/2025-11-24Z.md"
  },
  {
    "name": "2025-12-16Z.md",
    "path": "src/assets/release-notes/2025-12-16Z.md"
  },
  {
    "name": "2026-01-06Z.md",
    "path": "src/assets/release-notes/2026-01-06Z.md"
  },
  {
    "name": "2026-01-09Z.md",
    "path": "src/assets/release-notes/2026-01-09Z.md"
  },
  {
    "name": "2026-01-13Z.md",
    "path": "src/assets/release-notes/2026-01-13Z.md"
  },
  {
    "name": "2026-01-27Z.md",
    "path": "src/assets/release-notes/2026-01-27Z.md"
  },
  {
    "name": "2026-01-29Z.md",
    "path": "src/assets/release-notes/2026-01-29Z.md"
  },
  {
    "name": "2026-02-12Z.md",
    "path": "src/assets/release-notes/2026-02-12Z.md"
  },
  {
    "name": "2026-02-26Z.md",
    "path": "src/assets/release-notes/2026-02-26Z.md"
  },
  {
    "name": "2026-04-13Z.md",
    "path": "src/assets/release-notes/2026-04-13Z.md"
  },
  {
    "name": "2026-04-28Z.md",
    "path": "src/assets/release-notes/2026-04-28Z.md"
  },
  {
    "name": "2026-05-18Z.md",
    "path": "src/assets/release-notes/2026-05-18Z.md"
  },
  {
    "name": "2026-06-16Z.md",
    "path": "src/assets/release-notes/2026-06-16Z.md"
  },
  {
    "name": "release-notes.json",
    "path": "src/assets/release-notes/release-notes.json"
  }
]